// extracted by mini-css-extract-plugin
module.exports = {"main":"page_main__vy17a","container":"page_container__5cklw","faqContent":"page_faqContent__L71b7"};